import Axios from "../../config/axios";
import { getUnusedVoucher } from "../../redux/admin/CardInvoice/action";
import { getCurrentLanguage } from "../../helpers/Utils";

class CardInvoiceService {
  getDspUserList = async (data) => {
    return await Axios.get("/get-dsp-user-list-voucher", { params: data })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getTariff = async (data) => {
    return await Axios.get("/get-tariff", { params: data })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getUnusedVoucher = async (data) => {
    return await Axios.get("/get-unused-voucher", { params: data })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  geVoucherManagement = async (paramdata) => {
    // let currentDate = getDate1(new Date());
    let params = {
      params: paramdata,
    };

    if (paramdata?.isExcel || paramdata?.isPdf) {
      params.responseType = "arraybuffer";
    }

    return await Axios.get("/admin/get-voucher-management", params)
      .then(function (response) {
        const { data: data_1 } = response;

        // if (paramdata?.isExcel || paramdata?.isPdf) {

        //   const fileName = 'Voucher Management ' + currentDate;
        //   const blob = new Blob([data_1], {
        //     type: response?.headers['content-type'],
        //   });

        //   saveAs(blob, fileName);

        // } else {
        return data_1;
        // }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  saveInvoice = (invoiceData) => {
    return Axios.post("/manage-voucher-sale-request", invoiceData)
      .then((response) => {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

    getVoucherSearch = async (data) => {
    return await Axios.get("/get-voucher-search", { params: data })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

    checkVoucherInvoice = (data) => {
    return Axios.get("/verify-voucher-request", {
      params: data,
    })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
  
  generateDeliveryNotes = async (paramdata) => {

        paramdata = {
      ...paramdata,
      language: getCurrentLanguage(),
    };
  let params = {
    params: paramdata,
  };

  if (paramdata?.isPdf) {
    params.responseType = "arraybuffer";
  }

  return await Axios.get("/generate-delivery-notes", params)
    .then(function (response) {
      const { data: data_1 } = response;

      if (paramdata?.isPdf) {
        if (paramdata?.isPreview) {
          // Convert arraybuffer to blob for preview
          const blob = new Blob([data_1], {
            type: response?.headers['content-type'] || 'application/pdf',
          });
          return blob; // Return blob instead of raw arraybuffer
        }
        
        // Original download flow
        const fileName = 'Invoice';
        const blob = new Blob([data_1], {
          type: response?.headers['content-type'],
        });

        saveAs(blob, fileName);
        return null; 
      } else {
        return data_1;
      }
    })
    .catch((error) => {
      console.log(error);
      throw error; 
    });
};



  getTariff = async () => {
    return await Axios.get("/get-voucher-tariff")
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };




}

export default new CardInvoiceService();
